import { Switch } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import GlobalSendPage from './GlobalSendPage';

const GlobalSendRoutes: React.FC = () => {
  const featureFlags = useModuleFeatureFlag('globalSend');

  return (
    <Switch>
      <ProtectedRoute isAllowed={featureFlags.isEnabled} showPermission path="/global-send/:path">
        <GlobalSendPage />
      </ProtectedRoute>
    </Switch>
  );
};

export default GlobalSendRoutes;
